export default __webpack_public_path__ + "banner-framework260828e.png";